<template>
  <div class="execution">
    <div class="course-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input @keyup.enter.native="searchChange" class="course-filter-value" placeholder="课程名称" v-model.trim="search.name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input @keyup.enter.native="searchChange" class="course-filter-value" placeholder="课程讲师" v-model.trim="search.lecturer" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select v-model="search.courseGroupId" @change="searchChange" size="small" clearable placeholder="选择课程分组" filterable>
              <el-option
                v-for="item in courseGroups"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="course-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="course-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud ref="crud"
                 :page="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @size-change="sizeChange"
                 @current-change="currentChange"
                 @on-load="getList"
                 @row-del="rowDel">

        <template slot="name" slot-scope="scope">
            <div class="title">
              <div class="cover-image" v-if="scope.row.coverUrl" v-viewer>
                <img :src="scope.row.coverUrl | ossImageProcess">
              </div>
              <div class="name">
                {{scope.row.name}}
              </div>
            </div>
        </template>
        
        <template slot="courseTime" slot-scope="scope">
          <span>{{ formatTime(scope.row.courseTime) }}</span>
        </template>

        <template slot="miniProgramCodeUrl" slot-scope="scope">
          <el-button type="text" @click="previewMiniProgramQrcode(scope.row.id, scope.row.name, scope.row.nameEn)">
            点击查看
          </el-button>
        </template>

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.course_add">新增</el-button>
        </template>

        <template slot-scope="scope"
                  slot="menu">
          <el-button type="text"
                     v-if="permissions.course_update && scope.row.status === courseStatusEnums.INACTIVE.code"
                     size="mini"
                     @click="openPublishDialog(scope.row.status, scope.row.id)">上架</el-button>
          <el-button type="text"
                     v-if="permissions.course_update && scope.row.status === courseStatusEnums.ACTIVE.code"
                     size="mini"
                     @click="showPullOffDailog(scope.row.status, scope.row.id)">下架</el-button>
          <el-button type="text"
                     v-if="permissions.course_update && permissions.course_detail"
                     size="mini"
                     @click="handleEdit(scope.row,scope.index)">管理
          </el-button>
          <el-button type="text"
                     v-if="permissions.course_delete && scope.row.status === courseStatusEnums.INACTIVE.code"
                     size="mini"
                     @click="handleDel(scope.row,scope.index)">删除
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.course_update"
                     @click="handleSwitchTop(scope.row,scope.index,true)">置顶
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.course_update && scope.row.sort > 0"
                     @click="handleSwitchTop(scope.row,scope.index,false)">取消置顶
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.course_update"
                     @click="handleSentQuestionnaireNotice(scope.row)">发送问卷通知
          </el-button>
        </template>
      </avue-crud>
    </basic-container>

    <course-dialog v-if="showCourseDialog" :dialogVisible="showCourseDialog" @close="showCourseDialog=false" @confirm-save="getList(page)"/>
    <el-dialog
      :visible.sync="miniprogramQrcodeDialogVisible"
      fullscreen
      custom-class="preview-img-dialog"
      @closed="previewMiniProgramQrcodeUrl=''">
      <div @click="miniprogramQrcodeDialogVisible = false" class="qr-code">
        <img :src="previewMiniProgramQrcodeUrl" class="qr-code-img" width="70%"/>
        <p class="qr-code-name">{{previewCourseName}}</p>
        <p class="qr-code-name">{{previewCourseNameEn}}</p>
      </div>
    </el-dialog>

    <el-dialog
      title="上架课程"
      :visible.sync="coursePublishDialogVisible"
       width="35%">
       <template>
         <el-row class="dialog-body-row">您确定要上架该课程吗？</el-row>
         <el-row class="dialog-body-row">
           <el-checkbox v-model="isCoursePublishNotice">发送短信</el-checkbox>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="coursePublishDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSwitchStatus()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="下架课程"
      :visible.sync="coursePullOffDialogVisible"
       width="35%">
       <template>
         <el-row class="dialog-body-row">您确定要下架该课程吗？</el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="coursePullOffDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSwitchStatus()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="发送问卷通知"
      :visible.sync="relatedQuestionnaireDialogVisible"
      width="35%">
        <template>
          <el-row class="dialog-body-row">课程关联问卷</el-row>
          <el-row class="dialog-body-row">
            <div v-if="relatedQuestionnaireId" style="display:flex">
              <span>
                {{ relatedQuestionnaireName}}
              </span>
              <el-button
                type="text"
                icon="icon-remove-image"
                @click="removeRelatedQuestionnaire"
              />
            </div>
            <el-button
              v-else
              type="text"
              icon="icon-add-cover"
              @click="showQuestionnaireSelector=true"
            />
          </el-row>
          <el-row class="dialog-body-row">
            <el-checkbox v-model="isSentQuestionnaireNotice">发送短信通知</el-checkbox>
          </el-row>
        </template>
        <span slot="footer" class="dialog-footer">
          <el-row>
            <el-button @click="closeRelatedQuestionnaireDialog">取消</el-button>
            <el-button type="primary" @click="saveRelatedQuestionnaire">确定</el-button>
          </el-row>
        </span>
    </el-dialog>
    <questionnaire-selector v-if="showQuestionnaireSelector" :dialogVisible="showQuestionnaireSelector" :disabledQuestionnaireIds="relatedQuestionnaireIds" @close="showQuestionnaireSelector=false" @confirm-select="handleSelectQuestionnaire"/>
  </div>
</template>

<script>
import {fetchCourseList, changeCourseStatus, removeCourseById, updateCourseTopStatus, getCourseMiniProgramCode, relatedQuestionnaireId} from '@/api/app/course';
import Api from '@/api/app/activity';
import {courseTableOption, courseStatusEnums, courseGroupOptions} from '@/const/crud/app/course'
import { formatTime } from '../courseware/util/index';
import {mapGetters} from 'vuex';
import CourseDialog from './components/CourseDialog.vue';
import QuestionnaireSelector from '../../activity/list/components/QuestionnaireSelector.vue';

  export default {
    name: 'course',
    components: {
      CourseDialog,
      QuestionnaireSelector,
    },
    data() {
      return {
        id: undefined,
        tableData: [],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10 // 每页显示多少条
        },
        tableLoading: false,
        tableOption: courseTableOption,
        search: {
          current: 1,
          size: 10,
          name: '',
          lecturer: '',
          courseGroupId: undefined,
        },
        courseGroups: courseGroupOptions,
        showCourseDialog: false,
        courseStatusEnums: courseStatusEnums,
        miniprogramQrcodeDialogVisible: false,
        previewCourseName: '',
        previewCourseNameEn: '',
        previewMiniProgramQrcodeUrl: '',
        coursePublishDialogVisible: false,
        coursePullOffDialogVisible: false,
        isCoursePublishNotice: false,
        courseStatus: '',
        relatedQuestionnaireDialogVisible: false,
        showQuestionnaireSelector: false,
        currentCourse: '',
        relatedQuestionnaireIds: [],
        relatedQuestionnaireId: undefined,
        relatedQuestionnaireName: '',
        isSentQuestionnaireNotice: false,
      }
    },
    created() {
    },
    activated() {
      this.getList(this.page);
    },
    mounted: function () {
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      formatTime,
      getList(page) {
        this.tableLoading = true;
        let params = {
          current: page.currentPage,
          size: page.pageSize,
          keyword: this.search.name,
          lecturer: this.search.lecturer,
          groupId: this.search.courseGroupId
        }
        fetchCourseList(params).then(response => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total
          if (this.tableData && this.tableData.length > 0) {
            this.tableData.forEach(function(obj, index) {
              if (!obj.lecturer) { obj.lecturer = "--" }
              if (!obj.courseGroupName) { obj.courseGroupName = "--" }
            })
          }
          this.tableLoading = false;
        })
      },
      handleAdd() {
        this.$router.push('/app/course/course/add');
      },
      handleEdit(row, index) {
        if (row.id){
          this.$router.push({
            path: `/app/course/detail/${row.id}`,
          });
        } else {
          this.$message({
            showClose: true,
            message: '该课程不存在',
            type: 'warning',
          });
        }
      },
      handleDel(row, index) {
        this.$refs.crud.rowDel(row, index);
      },
      openPublishDialog(status, courseId) {
        this.id = courseId;
        this.coursePublishDialogVisible = true;
        this.courseStatus = status;
      },
      showPullOffDailog(status, courseId) {
        this.courseStatus = status;
        this.id = courseId;
        this.coursePullOffDialogVisible = true;
      },
      async handleSwitchStatus () {
        const msgRef = this.$message({
          type: 'warning',
          message: '正在' + (this.courseStatus === this.courseStatusEnums.INACTIVE.code ? '上架' : '下架') + '课程 ...',
          duration: 0,
        });
        this.courseStatus === this.courseStatusEnums.INACTIVE.code ? this.coursePublishDialogVisible = false : this.coursePullOffDialogVisible = false;
        const response = await this.requestWrapper(changeCourseStatus, this.id, { isSendMessage: this.isCoursePublishNotice });
        if (!response || response.ok === false) {
          this.$message({
            showClose: true,
            message: response.message || (this.courseStatus === this.courseStatusEnums.INACTIVE.code ? '上架' : '下架') + '课程失败',
            type: 'error',
          });
          return;
        }
        this.isCoursePublishNotice = false;
        this.getList(this.page)
        msgRef.close();
      },
      async rowDel (row, index) {
        var _this = this;
        this.$confirm('是否确认删除名称为' + row.name + '的课程?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async function () {
          const response = await _this.requestWrapper(removeCourseById, row.id);
          if (!response || response.ok === false) {
            _this.$message({
              showClose: true,
              message: response.message || '删除失败',
              type: 'error',
            });
            _this.getList(_this.page);
            return;
          }

          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
          _this.page.currentPage = 1;
          _this.getList(_this.page);
        }).catch(function (err) {
        })
      },
      initPage() {
        this.page.currentPage = 1;
        this.page.pageSize = this.search.size;
        this.search.current = 1;
      },
      searchChange() {
        this.initPage();
        this.getList(this.page);
      },
      searchReset() {
        this.search.name = '';
        this.search.lecturer = '';
        this.search.courseGroupId = undefined;
        this.getList(this.page);
      },
      sizeChange(val) {
        this.page.pageSize = val;
        this.search.size = val;
        this.getList(this.page);
      },
      currentChange(val) {
        this.page.currentPage = val;
        this.search.current = val;
        this.getList(this.page);
      },
      handleSwitchTop (row, index, isTop) {
        let params = {
          isTop: isTop,
        }
        this.$confirm('是否' + (isTop? '置顶' : '取消置顶') + '该课程?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateCourseTopStatus(row.id, params).then(response => {
            if (response.data.data) {
              this.$message({
                message: (isTop ? '置顶' : '取消置顶') + '成功',
                type: 'success'
              })
              this.getList(this.page);
            }
          }).catch(error => {
            this.$message({
              message: (isTop ? '置顶' : '取消置顶') + '失败',
              type: 'error'
            })
          })
        })
      },
      handleSentQuestionnaireNotice(row) {
        this.relatedQuestionnaireDialogVisible = true;
        this.currentCourse = this.tableData.find(item => item.id === row.id);
        this.relatedQuestionnaireId = this.currentCourse.relatedQuestionnaireId;
        this.relatedQuestionnaireName = this.currentCourse.relatedQuestionnaireName;
        this.isSentQuestionnaireNotice = this.currentCourse.isSentQuestionnaireNotice;
        this.initRelatedQuestionnaireIds();
      },
      handleSelectQuestionnaire(selectedQuestionnaire) {
        this.relatedQuestionnaireId = selectedQuestionnaire.id;
        this.relatedQuestionnaireName = selectedQuestionnaire.name;
        this.relatedQuestionnaireIds.push(selectedQuestionnaire.id);
      },
      removeRelatedQuestionnaire() {
        const relatedQuestionnaireIdIndex = this.relatedQuestionnaireIds.indexOf(this.relatedQuestionnaireId);
        this.relatedQuestionnaireIds.splice(relatedQuestionnaireIdIndex, 1);
        this.relatedQuestionnaireId = undefined;
      },
      initRelatedQuestionnaireIds() {
        Api.getProjectRelatedQuestionnaireIds().then(response => {
          if (response.data.code === 0) {
            this.relatedQuestionnaireIds = response.data.data;
          } else {
            this.$message(response.data.msg);
          }
        });
      },
      closeRelatedQuestionnaireDialog() {
        this.relatedQuestionnaireDialogVisible = false;
        this.initCurrentCourse();
      },
      saveRelatedQuestionnaire() {
        if (this.isSentQuestionnaireNotice && !this.relatedQuestionnaireId) {
          this.$message({
            message: '请选择关联问卷',
            type: 'error',
          });
          return;
        }
        relatedQuestionnaireId(
          this.currentCourse.id,  
          { 
            isSentQuestionnaireNotice: this.isSentQuestionnaireNotice,
            relatedQuestionnaireId: this.relatedQuestionnaireId,
          }
        )
        .then(response => {
          if (response.data.code === 0) {
            this.$message({
              message: '保存成功',
              type: 'success',
            });
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error',
            });
          }
          this.closeRelatedQuestionnaireDialog();
          this.getList(this.page);
        });
      },
      initCurrentCourse() {
        this.relatedQuestionnaireId = '';
        this.relatedQuestionnaireName = '';
        this.isSentQuestionnaireNotice = false;
      },
      previewMiniProgramQrcode(courseId, name, nameEn) {
        const messageRef = this.$message({
          message: "获取小程序二维码中...",
          type: "warning",
          duration: 0,
        });
        setTimeout(() => {
          getCourseMiniProgramCode(courseId).then((response) =>{
            messageRef.close();
            this.previewMiniProgramQrcodeUrl = response.data.data;
            this.miniprogramQrcodeDialogVisible = true;
            this.previewCourseName = name;
            this.previewCourseNameEn = nameEn;
          });
        }, 1000);
      }
    }
  }
</script>

<style lang="scss" scoped>
.course-filter {
  margin: 0 10px;
  /deep/ .el-input__inner {
    border: none;
    font-size: 14px;
  }
  .el-row {
    width: 95%;
  }
  &-label {
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }
  &-value {
    width: 96% !important;
  }
  &-search {
    float: right;
    margin-right: 8px;
  }
  &-reset {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
.title {
  display: flex;
  align-items: center;
  color: #606266;
  .cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
  .name {
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 170px;
    text-align: left;
  }
}
.qr-code {
  height: 84vh;
  width: 84vh;
  background-color: white;
  &-img {
    margin-top: 30px;
    user-select: none;
    pointer-events: none;
  }
  &-name {
    font-size: 20px;
    margin-top: 10px;
    font-weight: 600;
  }
}
/deep/ .el-dialog.preview-img-dialog{
  background: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      .el-dialog__close {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        border: 2px solid #fff;
        border-radius: 50%;
        padding: 5px;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
.dialog-body-row {
  line-height: 36px;
}
</style>
